import React from "react"

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            color: "#333",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          <h2 style={{ fontSize: "24px", marginBottom: "16px", fontWeight: "600" }}>
            Oops! Something went wrong.
          </h2>
          <p style={{ marginBottom: "24px", color: "#666", maxWidth: "400px" }}>
            We encountered an unexpected error. Please try reloading the page.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: "10px 24px",
              backgroundColor: "#db1215",
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
              transition: "background-color 0.2s",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#b00e10")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#db1215")}
          >
            Reload Page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
